import React from 'react';
import { Button } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

/**
 * CTAButton - unified call-to-action button used across the site.
 * Props:
 * - to: internal route (renders as react-router Link)
 * - href: external URL
 * - variant, size, colorScheme, children, leftIcon, rightIcon, onClick
 */
const CTAButton = ({ to, href, children, variant='solid', size='md', colorScheme='green', leftIcon, rightIcon, ...rest }) => {
  const common = { variant, size, colorScheme, leftIcon, rightIcon, ...rest };
  if (to) {
    return (
      <Button as={RouterLink} to={to} {...common}>
        {children}
      </Button>
    );
  }
  if (href) {
    return (
      <Button as="a" href={href} {...common}>
        {children}
      </Button>
    );
  }
  return <Button {...common}>{children}</Button>;
};

export default CTAButton;
